// Import model
import { ContactTaskCondition } from '../models/ContactTaskCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { ContactTaskIndexedFields } from '../models/ContactTaskIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { ContactTaskIndexedFieldsSerializer } from './ContactTaskIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ContactTaskCondition - handles JSON serialization and deserialization with type validation
 */
export class ContactTaskConditionSerializer {
  /**
   * Deserializes a JSON string into a ContactTaskCondition instance
   */
  static deserialize(json: string): ContactTaskCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ContactTaskCondition instance
   */
  static fromObject(obj: any): ContactTaskCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ContactTaskCondition');
    }


    const instance: ContactTaskCondition = {
      fieldName: obj['fieldName'] as ContactTaskIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ContactTaskCondition instances
   */
  static deserializeArray(json: string): ContactTaskCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ContactTaskCondition instance to a JSON string
   */
  static serialize(instance: ContactTaskCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ContactTaskCondition instance to a plain object
   */
  static toObject(instance: ContactTaskCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of ContactTaskCondition instances to a JSON string
   */
  static serializeArray(instances: ContactTaskCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
